import React from 'react';

import { Image } from '@uncinc/uncinc-react-kitchen-sink';

import type { SearchAllContentEquipmentHit as Type } from '../../../../SearchAllContent/types';
import constructVariableRatiosImageSourcesObject from '../../../../../helpers/constructImageSources';

import NodeEquipmentCard from '../../../../../implementations/Node/Equipment/Card';

const MetaSearchEquipmentHit: React.FC<{ hit: Type }> = ({ hit }) => (
  <NodeEquipmentCard
    title={hit.page_title[0]}
    subtitle={hit.body?.[0] ? hit.body?.[0] : hit.paragraphs_body_processed?.[0]}
    image={(
      <Image
        src={constructVariableRatiosImageSourcesObject(
          hit,
          ['4_3', '4_3', '4_3', '4_3', '4_3'],
          ['sm', 'xxs', 'xs', 'sm', 'sm'],
        )}
        alt=""
        lazyload={false}
      />
    )}
    link={hit.url[0]}
  />
);

export default MetaSearchEquipmentHit;
